// src/pages/news/Downloads.js
import React, { useState } from 'react';
import './Downloads.css';
import windowsInstall1 from '../../assets/images/windows_install_1.png';
import windowsInstall2 from '../../assets/images/windows_install_2.png';

const Downloads = () => {
  const [showGuide, setShowGuide] = useState(null);

  const handleDownload = (platform, url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleShowGuide = (platform) => {
    setShowGuide(showGuide === platform ? null : platform);
  };

  const downloadItems = [
    {
      platform: 'Windows',
      icon: 'fab fa-windows',
      description: 'Download for Windows',
      url: 'https://drive.google.com/file/d/1SYqVMDWylJMGo4SWY2TPNumlLlCoG283',
      available: true,
      color: '#0078d4'
    },
    {
      platform: 'macOS',
      icon: 'fab fa-apple',
      description: 'Download for macOS',
      url: null,
      available: false,
      color: '#000000'
    },
    {
      platform: 'Android',
      icon: 'fab fa-android',
      description: 'Download APK file',
      url: null,
      available: false,
      color: '#3ddc84'
    },
    {
      platform: 'iOS',
      icon: 'fab fa-app-store-ios',
      description: 'Download from App Store',
      url: null,
      available: false,
      color: '#007aff'
    }
  ];

  return (
    <div className="downloads-page">
      <div className="container">
        <div className="downloads-header">
          <h1 className="downloads-title">
            <i className="fas fa-download me-3"></i>
            Download Aullan Clinic App
          </h1>
          <p className="downloads-subtitle">
            Get the Aullan Clinic application on your preferred platform for seamless medical practice management.
          </p>
        </div>

        <div className="downloads-grid">
          {downloadItems.map((item, index) => (
            <div key={index} className={`download-card ${!item.available ? 'disabled' : ''}`}>
              <div className="download-icon" style={{ color: item.color }}>
                <i className={item.icon}></i>
              </div>
              <h3 className="download-platform">{item.platform}</h3>
              <p className="download-description">{item.description}</p>
              
              {item.available ? (
                <div className="download-actions">
                  <button 
                    className="download-btn"
                    onClick={() => handleDownload(item.platform, item.url)}
                    style={{ backgroundColor: item.color }}
                  >
                    <i className="fas fa-download me-2"></i>
                    Download Now
                  </button>
                  {(item.platform === 'Windows' || item.platform === 'Android') && (
                    <button 
                      className="guide-btn"
                      onClick={() => handleShowGuide(item.platform)}
                    >
                      <i className="fas fa-question-circle me-2"></i>
                      Installation Guide
                    </button>
                  )}
                </div>
              ) : (
                <div className="coming-soon">
                  <i className="fas fa-clock me-2"></i>
                  Coming Soon
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Installation Instructions */}
        {showGuide && (
          <div className="installation-guide">
            {showGuide === 'Android' && (
              <div className="guide-card">
                <div className="guide-header">
                  <h3>
                    <i className="fab fa-android me-2"></i>
                    Android Installation Guide
                  </h3>
                  <button 
                    className="close-guide-btn"
                    onClick={() => setShowGuide(null)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                <p className="guide-intro">
                  To install the Android APK file, you need to enable installation from unknown sources:
                </p>
                
                <div className="installation-steps">
                  <div className="step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h4>Enable Unknown Sources</h4>
                      <p>Go to <strong>Settings &gt; Security</strong> (or <strong>Privacy</strong>) and enable <strong>"Unknown sources"</strong> or <strong>"Install unknown apps"</strong>.</p>
                    </div>
                  </div>

                  <div className="step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h4>Download APK</h4>
                      <p>Download the APK file from the link above. You may need to download it from Google Drive to your device.</p>
                    </div>
                  </div>

                  <div className="step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h4>Install APK</h4>
                      <p>Open the downloaded APK file and follow the installation prompts. You may see a security warning - tap "Install anyway" to proceed.</p>
                    </div>
                  </div>
                </div>

                <div className="security-note">
                  <i className="fas fa-shield-alt me-2"></i>
                  <strong>Security Note:</strong> Only install APK files from trusted sources. This app is safe to install.
                </div>
              </div>
            )}

            {showGuide === 'Windows' && (
              <div className="guide-card">
                <div className="guide-header">
                  <h3>
                    <i className="fab fa-windows me-2"></i>
                    Windows Installation Guide
                  </h3>
                  <button 
                    className="close-guide-btn"
                    onClick={() => setShowGuide(null)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                <p className="guide-intro">
                  If you see a Microsoft Defender SmartScreen warning when installing, follow these steps:
                </p>
                
                <div className="installation-steps">
                  <div className="step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h4>Click "More info"</h4>
                      <p>When you see the SmartScreen warning, click on "More info" to reveal additional options.</p>
                      <div className="step-image">
                        <img src={windowsInstall1} alt="Click More info on SmartScreen warning" />
                      </div>
                    </div>
                  </div>

                  <div className="step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h4>Click "Run anyway"</h4>
                      <p>After clicking "More info", you'll see a "Run anyway" button. Click it to proceed with the installation.</p>
                      <div className="step-image">
                        <img src={windowsInstall2} alt="Click Run anyway to proceed" />
                      </div>
                    </div>
                  </div>

                  <div className="step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h4>Complete Installation</h4>
                      <p>Follow the installation wizard to complete the setup. The app will be ready to use once installed.</p>
                    </div>
                  </div>
                </div>

                <div className="security-note">
                  <i className="fas fa-shield-alt me-2"></i>
                  <strong>Security Note:</strong> This warning appears because the app is not yet digitally signed. 
                  The application is safe to install and use.
                </div>
              </div>
            )}
          </div>
        )}

        <div className="downloads-info">
          <div className="info-card">
            <h3>
              <i className="fas fa-info-circle me-2"></i>
              System Requirements
            </h3>
            <ul>
              <li><strong>Windows:</strong> Windows 7 or later</li>
              <li><strong>macOS:</strong> macOS 10.14 or later</li>
              <li><strong>Android:</strong> Android 7.0 (API level 24) or higher</li>
              <li><strong>iOS:</strong> iOS 12.0 or later</li>
            </ul>
          </div>

          <div className="info-card">
            <h3>
              <i className="fas fa-star me-2"></i>
              Features
            </h3>
            <ul>
              <li>Patient management system</li>
              <li>Appointment scheduling</li>
              <li>Medical records management</li>
              <li>Prescription management</li>
              <li>Secure data synchronization</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;
